module.exports = __webpack_public_path__ + "static/media/sales.e57797de.jpg";